import styled from '@emotion/styled';
import React, { LegacyRef, useEffect, useRef } from 'react';
import { useRecoilValue } from 'recoil';
import PaymentWayTable from '../table/PaymentWayTable';
import useReset from '../../../../../hooks/common/useReset';
import { isCompareInfoState } from '../../../../../data/estimate/common/paymentWay/info/atom';
import { SelectInfo } from '../../../../../types/estimate/common/EstimateInfo';
import useActiveTab from '../../../../../hooks/estimate/common/useActiveTab';

const Base = styled.div<{ isDisplay: boolean }>`
  display: ${props => (props.isDisplay ? 'flex' : 'none')};
  gap: 8px;
`;

/**
 *  지불방법 비교 테이블을 감싸는 컴포넌트
 *  */
function CompareTableAreaa(): JSX.Element {
  // ref
  const baseRef: LegacyRef<HTMLDivElement> = useRef(null);

  // tab
  const { id } = useActiveTab();

  // reset
  useReset(isCompareInfoState);

  // select
  const isCompareInfo: SelectInfo<boolean>[] = useRecoilValue(isCompareInfoState);
  const isCompare: boolean = isCompareInfo[id - 1].info || false;

  useEffect(() => {
    // const base: HTMLDivElement | null = baseRef.current;
    // if (base && isCompare) {
    //   // 비교추가가 클릭되었을 때 스크롤을 자연스럽게 비교추가 지불방법 테이블 위치로 오게 한다.
    //   const top: number = (base.offsetTop || 0) - 100;
    //   window.scroll({
    //     left: 0,
    //     top,
    //     behavior: 'smooth',
    //   });
    // }
  }, [isCompareInfo]);

  return (
    <Base ref={baseRef} isDisplay={isCompare}>
      <PaymentWayTable tableNo={2} />
      <PaymentWayTable tableNo={3} />
      <PaymentWayTable tableNo={4} />
    </Base>
  );
}

export default CompareTableAreaa;
